import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DegreeRoutingModule } from './degree-routing.module';
import { DegreeListComponent } from './degree-list/degree-list.component';
import { DegreeCreateComponent } from './degree-create/degree-create.component';

import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2SmartTableModule } from 'ng2-smart-table';

@NgModule({
  declarations: [DegreeListComponent, DegreeCreateComponent],
  imports: [
    CommonModule,
    DegreeRoutingModule,
    ReactiveFormsModule,
    NgbModule,
    Ng2SmartTableModule
  ]
})
export class DegreeModule { }
